import React from "react";
import "./RunQueue.css";
import { fleetStripModel, fleetStripText, relativeTime } from "./runQueueFormat";

/**
 * One-line fleet summary — "GPUs 41/90 busy · 12 jobs waiting · 2 runs in GPU
 * phase · queue 4" — shown at the top of the dashboard run list and in the
 * multi-project Run-queue panel. Data comes from useRunQueue (fleet + queue).
 */
function FleetStrip({ fleet, queue, loading = false, compact = false, className = "" }) {
  const model = fleetStripModel(fleet, queue);
  const hasAny = Boolean(fleet || queue);
  const text = hasAny ? fleetStripText(model) : loading ? "Fleet: loading…" : "Fleet: no data yet";
  const tooltipParts = [];
  if (model.lastTick) tooltipParts.push(`Controller tick ${relativeTime(model.lastTick)}`);
  if (model.waitingReason) tooltipParts.push(`Head of queue waiting: ${model.waitingReason}`);
  if (model.fleetError) tooltipParts.push(`Fleet probe: ${model.fleetError}`);
  const title = tooltipParts.join(" — ") || "GPU fleet and run-queue status";

  return (
    <div
      className={`fleet-strip${compact ? " fleet-strip--compact" : ""}${className ? ` ${className}` : ""}`}
      title={title}
      role="status"
      aria-live="polite"
      data-testid="fleet-strip"
    >
      <i className="fa-solid fa-microchip fleet-strip-icon" aria-hidden />
      <span className="fleet-strip-text">{text}</span>
      {model.waitingReason && !compact && (
        <span className="fleet-strip-reason" title={model.waitingReason}>
          {model.waitingReason}
        </span>
      )}
    </div>
  );
}

export default FleetStrip;
